(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDeleteController',VentamesdiaDeleteController);

    VentamesdiaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventamesdia'];

    function VentamesdiaDeleteController($uibModalInstance, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventamesdia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
